import { Bold, Essentials, Heading, Italic, List, MultiLevelList, Paragraph, Table, Strikethrough, Underline, Alignment, PageBreak, Link, Indent, IndentBlock, Notification, Permissions, } from 'shared/domains/pleditor@next';
export const PREVIEW_PLUGINS = [
    Bold,
    Essentials,
    Heading,
    Italic,
    List,
    MultiLevelList,
    Paragraph,
    Table,
    Strikethrough,
    Underline,
    Alignment,
    PageBreak,
    Link,
    Indent,
    IndentBlock,
    Notification,
    Permissions,
];
